"use strict";

var core = require("../helpers/core");
var storage = require("./storage").session;

var lang = "en-GB";

var elementIds = {
    langContainer: "home-search-lang",
    trucks: {
        vehicleType: "home-truck-vehicle-type",
        makes: "home-truck-make-id",
        prices: "home-truck-price-to",
        substructures: "home-truck-substructure-id",
        country: "home-truck-country",
        postalCode: "home-truck-zip",
        mainContainer: "home-box-trucks-search",
        form: "search-truck-form",
        button: "home-truck-button",
        refineSearch: "refine-search-trucks"
    },
    caravans: {
        vehicleType: "home-caravan-vehicle-type",
        makes: "home-caravan-make-id",
        prices: "home-caravan-price-to",
        substructures: "home-caravan-substructure-id",
        country: "home-caravan-country",
        postalCode: "home-caravan-zip",
        mainContainer: "home-box-caravan-search",
        form: "search-caravan-form",
        button: "home-caravan-button",
        refineSearch: "refine-search-caravans"
    }
};

var isTouchDevice = function() {
    return document.querySelector(".search-mask[data-device-type=\"Mobile\"]");
};

var getStorageKey = function(dataType) {
    return "last_home_search_" + document.getElementById(elementIds.langContainer).getAttribute("data-lang") + "_" + dataType;
};

var doWithSearchCriteria = function(dataType, delegate, includeHiddenInputs) {
    Array.prototype.forEach.call(
        document
            .getElementById(elementIds[dataType].mainContainer)
            .querySelectorAll("form select" + (includeHiddenInputs ? ", form input" : ", form input:not([type=\"hidden\"])")),
        function(criterion) { delegate(criterion); }
    );
};

var findCriterionByName = function(dataType, name) {
    return document.getElementById(elementIds[dataType].mainContainer).querySelector("form [name='" + name + "']");
};

var resetSelectElement = function(element) {
    var title = element.options[0].text;
    element.innerHTML = "";
    element.disabled = true;
    core.appendOption(element, "0", title);
    element.value = "0";
};

var updateSelectElement = function(element, valuePairs, valueTransformer) {
    resetSelectElement(element);
    valuePairs.forEach(function(pair){
        var data = valueTransformer(pair);
        core.appendOption(element, data.value, data.text);
    });
    element.disabled = false;
};


var formSerializer = function(dataType) {
    var isNumber = function(value) { return !isNaN(parseInt(value)); };

    var getCountryId = function() {
        var countrySelect = document.getElementById(elementIds[dataType].country);
        return countrySelect ? (countrySelect.getAttribute("data-default") || "") : "";
    };

    var getQueryString = function(paramNameMapping) {
        var vehicleTypeParamName = paramNameMapping.vehicletype_id || "vehicletype_id";
        var params = {};
        doWithSearchCriteria(dataType, function(elem) {
            var allowsEmpty = elem.getAttribute("data-allows-empty") === "true";
            var paramName = paramNameMapping[elem.name] || elem.name;
            if (!isNumber(elem.value)) {
                if (elem.value || allowsEmpty) {
                    params[paramName] = encodeURIComponent(elem.value);
                }
            }
            else if (elem.value > 0) {
                params[paramName] = elem.value;
            }
            else if (paramName === vehicleTypeParamName) {
                params[paramName] = "1";
            }
        }, true);
        if (!params.zip) {
            delete params.radius;
        }

        var countryParam = paramNameMapping.country ? paramNameMapping.country : "country";
        if(!params[countryParam] || params[countryParam].length === 0) {
            params[countryParam] = getCountryId();
        }

        return Object.keys(params).map(function(paramName) {
            return paramName + "=" + params[paramName];
        }).join("&");
    };

    var getMobileQueryString = function() {
        return getQueryString({
            "vehicletype_id": "vehicleTypeId",
            "make": "makeId",
            "substructure_id": "substructureId",
            "yearfrom": "firstRegistrationYearFrom",
            "country": "countryId"
        });
    };

    var getDesktopQueryString = function() {
        return getQueryString({});
    };

    return {
        getQueryString: function (skipQuestionMark) {
            return (skipQuestionMark ? "" : "?") + (isTouchDevice() ? getMobileQueryString() : getDesktopQueryString());
        }
    };
};

var formSerializers = {
    "trucks": formSerializer("trucks"),
    "caravans": formSerializer("caravans")
};

var idAndNameDeserializer = function(object) {
  return {
      value: object.id,
      text: object.name
  };
};

var updateCriteriaBasedOnVehicleType = function(vehicleTypeElement, delegate) {
    var truckElementIds = elementIds.trucks;
    var vehicleTypeId = vehicleTypeElement.value;
    if(vehicleTypeId === "0") {
        [truckElementIds.substructures, truckElementIds.makes, truckElementIds.prices].forEach(function(id){
            resetSelectElement(document.getElementById(id));
        });
    } else {
        var url = "/home/trucks/vehicleTypes/" + vehicleTypeId + "?lang=" + lang;
        core.ajax(url, "GET", function(result){
            updateSelectElement(document.getElementById(truckElementIds.substructures), result.substructures, idAndNameDeserializer);
            updateSelectElement(document.getElementById(truckElementIds.makes), result.makes, idAndNameDeserializer);
            updateSelectElement(document.getElementById(truckElementIds.prices), result.prices, idAndNameDeserializer);
            if (delegate) {
                delegate();
            }
        }, "application/json", false);
    }
};

var persistSearchCriteria = function(dataType) {
    var currentCriteria = {};
    doWithSearchCriteria(dataType, function(criterion) {
        currentCriteria[criterion.name] = criterion.value;
    });
    storage.set(getStorageKey(dataType), currentCriteria);
};

var restoreSavedSearchCriteria = function(dataType, criteriaUpdater) {
    var criteriaToRestore = storage.get(getStorageKey(dataType));
    if (criteriaToRestore) {
        criteriaUpdater(criteriaToRestore);
    }
};

var updateTruckSearchCriteria = function(criteria) {
    var dependentOfVehicleType = [], independentOfVehicleType = [];
    Object.keys(criteria).forEach(function(key) {
        var criterion = findCriterionByName("trucks", key);
        if (criterion.getAttribute("data-vehicle-type-dependant") === "true") {
            dependentOfVehicleType.push(criterion);
        }
        else {
            independentOfVehicleType.push(criterion);
        }
    });
    independentOfVehicleType.forEach(function(criterion) { criterion.value = criteria[criterion.name]; });

    var vehicleTypeCriterion = document.getElementById(elementIds.trucks.vehicleType);
    var vehicleTypeValue = criteria[vehicleTypeCriterion.name];
    if (vehicleTypeValue) {
        delete criteria[vehicleTypeCriterion.name];
        updateCriteriaBasedOnVehicleType(vehicleTypeCriterion, function() {
            dependentOfVehicleType.forEach(function(criterion) {
                criterion.value = criteria[criterion.name];
            });
        });
    }
};

var updateCaravanSearchCriteria = function(criteria) {
    Object.keys(criteria).forEach(function(key) {
        findCriterionByName("caravans", key).value = criteria[key];
    });
};

var updatePostalCode = function(postalCodeInput, criterionValue) {
    postalCodeInput.value = criterionValue ? postalCodeInput.value : "";
    postalCodeInput.disabled = !criterionValue;
};

var initSearchCriteria = function(dataType) {
    var postalCodeInput = document.getElementById(elementIds[dataType].postalCode);
    var country = document.getElementById(elementIds[dataType].country);
    updatePostalCode(postalCodeInput, country.value);
    doWithSearchCriteria(dataType, function(criterion) {
        core.addEvent(criterion, "change", function() {
            if(criterion.name === "country"){
                updatePostalCode(postalCodeInput, criterion.value);
            }
            persistSearchCriteria(dataType);
        });
    });
};

var disableSubmitAndInitButton = function(dataType) {
    var searchForm = document.getElementById(elementIds[dataType].form);
    var searchButton = document.getElementById(elementIds[dataType].button);
    core.addEvent(searchForm, "submit", function(ev) { ev.preventDefault(); });
    core.addEvent(searchButton, "click", function(event) {
        event.preventDefault();
        document.location = searchForm.getAttribute("data-action") + formSerializers[dataType].getQueryString();
    });
};

var initRefineSearchLinks = function(dataType) {
    var link = document.getElementById(elementIds[dataType].refineSearch);
    core.addEvent(link, "click", function (event) {
        document.location =
            link.getAttribute("href").split("?")[0] +
            (isTouchDevice() ? "?search=1&" : "?mid=10&language=ger&") +
            formSerializers[dataType].getQueryString(true);
        event.preventDefault();
    });
};

var initTrucksSearchMask = function(){
    var vehicleTypeSelect = document.getElementById(elementIds.trucks.vehicleType);
    core.addEvent(vehicleTypeSelect, "change", function() {
        updateCriteriaBasedOnVehicleType(vehicleTypeSelect, function() {
            storage.remove(getStorageKey("trucks"));
            persistSearchCriteria("trucks");
        });
    });
    restoreSavedSearchCriteria("trucks", updateTruckSearchCriteria);
    initSearchCriteria("trucks");
    disableSubmitAndInitButton("trucks");
    initRefineSearchLinks("trucks");
};

var initCaravansSearchMask = function(){
    restoreSavedSearchCriteria("caravans", updateCaravanSearchCriteria);
    initSearchCriteria("caravans");
    disableSubmitAndInitButton("caravans");
    initRefineSearchLinks("caravans");
};

var initSearchMasks = function() {
    var langElement = document.getElementById("home-search-lang");
    lang = langElement !== null ? langElement.getAttribute("data-lang") : lang;

    if (document.getElementById(elementIds.trucks.mainContainer)) {
        initTrucksSearchMask();
    }
    if (document.getElementById(elementIds.caravans.mainContainer)) {
        initCaravansSearchMask();
    }
};

module.exports = {
    init: initSearchMasks
};
